import { useContext } from 'react';
import i18nContext from 'components/i18n-context';

const CSV_COLUMNS = [
  // Required
  { key: 'senderWallet', required: 'yes' },
  { key: 'amount', required: 'yes' },
  { key: 'currency', required: 'yes' },
  { key: 'accountNumber', required: 'yes' },
  { key: 'beneficiaryType', required: 'yes' },
  // Conditional
  { key: 'comment', required: 'conditional' },
  { key: 'paymentPurpose', required: 'conditional' },
  { key: 'sortCode', required: 'conditional' },
  { key: 'cryptoNetwork', required: 'conditional' },
  { key: 'bankName', required: 'conditional' },
  { key: 'bankCountry', required: 'conditional' },
  { key: 'beneficiaryFirstName', required: 'conditional' },
  { key: 'beneficiaryLastName', required: 'conditional' },
  { key: 'beneficiaryCompanyName', required: 'conditional' },
  { key: 'registrationNumber', required: 'conditional' },
  { key: 'beneficiaryCountry', required: 'conditional' },
  { key: 'beneficiaryAddress', required: 'conditional' },
  { key: 'beneficiaryCity', required: 'conditional' },
  { key: 'beneficiaryPostCode', required: 'conditional' },
  // Optional
  { key: 'bic', required: 'no' }
];

const CsvFormatTable = () => {
  const i18n = useContext(i18nContext);

  return (
    <div className={'csv-format-table-wrapper'}>
      <table className={'csv-format-table'}>
        <thead>
          <tr>
            <th>#</th>
            <th>{i18n.getMessage('csvImport.table.column')}</th>
            <th>{i18n.getMessage('csvImport.table.required')}</th>
            <th>{i18n.getMessage('csvImport.table.notes')}</th>
          </tr>
        </thead>
        <tbody>
          {CSV_COLUMNS.map((col, index) => (
            <tr key={col.key}>
              <td>{index + 1}</td>
              <td>{i18n.getMessage(`csvImport.column.${col.key}`)}</td>
              <td>{i18n.getMessage(`csvImport.required.${col.required}`)}</td>
              <td>{i18n.getMessage(`csvImport.column.${col.key}.notes`)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CsvFormatTable;
